module.exports = __webpack_public_path__ + "static/media/abs-hotline2.67f03e35.png";